import React, { useEffect, useState, useContext, useRef } from 'react';
import { Modal, Table, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './Styles.css';

function BatteryEnergy({ SN, Combinations }) {
    const { t } = useTranslation();

    const [direct, setDirect] = useState("ToBattery");
    const [icon, setIcon] = useState("images/inverter/battery_charge.png");
    const [title, setTitle] = useState(t('Battery Charge'));
    const [dayTitle, setDayTitle] = useState(t('Today Charge'));
    const [totalTitle, setTotalTitle] = useState(t('Total Charge'));

    useEffect(() => {
        if (direct === "FromBattery") {
            setIcon("images/inverter/battery_discharge.png");
            setTitle(t('Battery Discharge'));
            setDayTitle(t('Today Discharge'));
            setTotalTitle(t('Total Discharge'));
        } else {
            setIcon("images/inverter/battery_charge.png");
            setTitle(t('Battery Charge'));
            setDayTitle(t('Today Charge'));
            setTotalTitle(t('Total Charge'));
        }
    })

    const handleClick = () => {
        if (direct === "ToBattery") {
            setDirect("FromBattery");
        } else {
            setDirect("ToBattery");
        }
    }

    const showDetails = (e) => {
        e.stopPropagation();

        Modal.info({
            maskClosable: true,
            width: "85%",
            icon: null,
            title: t("Battery Charge/Discharge"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase == 2 ? "(A)" : r.Phase == 3 ? "(B)" : r.Phase == 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("Daily Charge/Discharge (kWh)"), dataIndex: "EDayToBattery",  render: (v,r) => {
                        if (v == null) {
                            v ="-";
                        } else {
                            v = parseInt(v);
                            v = (v * 0.01).toFixed(2);
                        }
                        let v2 = r["EDayFromBattery"];
                        if (v2 == null) {
                            v2 = "-";
                        } else {
                            v2 = parseInt(v2);
                            v2 = (v2 * 0.01).toFixed(2);
                        }
                        return `${v} / ${v2}`;
                    }},
                    { title: t("Monthly Charge/Discharge (kWh)"), dataIndex: "EMonthToBattery",  render: (v,r) => {
                        if (v == null) {
                            v ="-";
                        } else {
                            v = parseInt(v);
                            v = (v * 0.01).toFixed(2);
                        }
                        let v2 = r["EMonthFromBattery"];
                        if (v2 == null) {
                            v2 = "-";
                        } else {
                            v2 = parseInt(v2);
                            v2 = (v2 * 0.01).toFixed(2);
                        }
                        return `${v} / ${v2}`;
                    }},
                    { title: t("Yearly Charge/Discharge (kWh)"), dataIndex: "EYearToBattery",  render: (v,r) => {
                        if (v == null) {
                            v ="-";
                        } else {
                            v = parseInt(v);
                            v = (v * 0.01).toFixed(2);
                        }
                        let v2 = r["EYearFromBattery"];
                        if (v2 == null) {
                            v2 = "-";
                        } else {
                            v2 = parseInt(v2);
                            v2 = (v2 * 0.01).toFixed(2);
                        }
                        return `${v} / ${v2}`;
                    }},
                    { title: t("Total Charge/Discharge (kWh)"), dataIndex: "ETotalToBattery",  render: (v,r) => {
                        if (v == null) {
                            v ="-";
                        } else {
                            v = parseInt(v);
                            v = (v * 0.01).toFixed(2);
                        }
                        let v2 = r["ETotalFromBattery"];
                        if (v2 == null) {
                            v2 = "-";
                        } else {
                            v2 = parseInt(v2);
                            v2 = (v2 * 0.01).toFixed(2);
                        }
                        return `${v} / ${v2}`;
                    }},
                ]}
                summary={(data) => {
                    if (!data || data.length < 2) {
                        return null;
                    }
                    let EDayToBattery = 0;
                    let EDayFromBattery = 0;
                    let EMonthToBattery = 0;
                    let EMonthFromBattery = 0;
                    let EYearToBattery = 0;
                    let EYearFromBattery = 0;
                    let ETotalToBattery = 0;
                    let ETotalFromBattery = 0;
                    data.forEach((item, index) => {
                        if (item.EDayToBattery != null ) {
                            let v = parseInt(item.EDayToBattery);
                            EDayToBattery += v * 0.01;
                        }
                        if (item.EDayFromBattery != null ) {
                            let v = parseInt(item.EDayFromBattery);
                            EDayFromBattery += v * 0.01;
                        }
                        if (item.EMonthToBattery != null ) {
                            let v = parseInt(item.EMonthToBattery);
                            EMonthToBattery += v * 0.01;
                        }
                        if (item.EMonthFromBattery != null ) {
                            let v = parseInt(item.EMonthFromBattery);
                            EMonthFromBattery += v * 0.01;
                        }
                        if (item.EYearToBattery != null ) {
                            let v = parseInt(item.EYearToBattery);
                            EYearToBattery += v * 0.01;
                        }
                        if (item.EYearFromBattery != null ) {
                            let v = parseInt(item.EYearFromBattery);
                            EYearFromBattery += v * 0.01;
                        }
                        if (item.ETotalToBattery != null ) {
                            let v = parseInt(item.ETotalToBattery);
                            ETotalToBattery += v * 0.01;
                        }
                        if (item.ETotalFromBattery != null ) {
                            let v = parseInt(item.ETotalFromBattery);
                            ETotalFromBattery += v * 0.01;
                        }
                    });
                    return (
                        <>
                            <Table.Summary.Row style={{fontWeight:"bold"}}>
                                <Table.Summary.Cell index={0} colSpan={2} align='right'>{t("Subtotal")}</Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>{EDayToBattery.toFixed(2)} / {EDayFromBattery.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{EMonthToBattery.toFixed(2)} / {EMonthFromBattery.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{EYearToBattery.toFixed(2)} / {EYearFromBattery.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{ETotalToBattery.toFixed(2)} / {ETotalFromBattery.toFixed(2)}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
                dataSource={Combinations}
                scroll={{ x: true }}
            />),
            onOk() {
            },
        });
    };

    let EDay = 0;
    let ETotal = 0;
    let count = Combinations?.length || 0;

    if (Combinations != null) {
        Combinations.forEach((item, index) => {
            if (item[`EDay${direct}`] != null ) {
                let v = parseInt(item[`EDay${direct}`]);
                EDay += v * 0.01;
            }
            if (item[`ETotal${direct}`] != null ) {
                let v = parseInt(item[`ETotal${direct}`]);
                ETotal += v * 0.01;
            }
        });
    }
    

    return (<div className="combination-stats-block" style={{cursor:"pointer"}} onClick={handleClick}>
        <div className="title" style={{ backgroundColor: '#92b5c9' }}>
            {title}
            <Button ghost size='small' shape="round" onClick={showDetails}>{t("Details")}</Button>
        </div>
        <div className="content" >
            <div className="left">
                <img src={icon} alt={t('Battery Charge/Discharge')}></img>
            </div>
            <div className="right">
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {EDay.toFixed(2)} {t('kWh')}
                    {count > 1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{dayTitle}</div>
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {ETotal.toFixed(2)} {t('kWh')}
                    {count > 1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{totalTitle}</div>
            </div>
        </div>
    </div>);
}

export default BatteryEnergy;